import React, { useState, useEffect } from "react";
import OnboardHeading from "../../components/OnboardHeading";
import BackButtonComponent from "../../components/backButton";
import PayrollFilter from "../../components/PayrollFilter";
import moment from "moment";
import "./style.scss";
import PayrollTable from "../../components/PayrollTable";
import { postData } from "../../api";
import { toast } from "react-toastify";
import { autocloseTiming } from "../../api/regex";
import Loader from "../../components/Loader";
import { Modal } from "react-bootstrap";
import PayrollPreview from "../PayrollPreview";

const PayrollReportFilter = () => {
  const [showFilter, setShowFilter] = useState(true);
  const [filterOptions] = useState([]);
  const [dateRange, setDateRange] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [applybtnDisable, setApplybtnDisable] = useState(true);
  const [, setLoading] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [apiCallsInProgress, setApiCallsInProgress] = useState(0);
  const [filteredTableData, setFilteredTableData] = useState([]);
  // const [csvLoading, setCsvLoading] = useState(false);
  // const [pdfLoading, setPdfLoading] = useState(false);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  // const [sortOrder, setSortOrder] = useState("desc");
  const [, setAppliedFilters] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState({
    end_date: "",
    start_date: "",
  });
  const [viewData, setViewData] = useState([]);
  const [showModalPreview, setShowModalPreview] = useState(false);

  const handleApiStart = () => {
    setApiCallsInProgress((prev) => prev + 1);
    setLoading(true);
  };
  const handleApiEnd = () => {
    setApiCallsInProgress((prev) => {
      const newCount = prev - 1;
      if (newCount === 0) {
        setLoading(false);
      }
      return newCount;
    });
  };
  const handleGetUserInfo = async () => {
    handleApiStart();
    const res = await postData("get_user_details", {}, {});
    try {
      if (res?.status === true) {
        setLoading(false);
        setUserInfo(res?.data);
      } else {
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    } finally {
      handleApiEnd();
    }
  };

  useEffect(() => {
    handleGetUserInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getTableData = async () => {
    handleApiStart();
    const payLoad = {
      client_id: userInfo?.client_id,
      user_id: userInfo?.user_id,
    };
    try {
      const res = await postData("payroll-journal-view", {}, payLoad);
      if (res.status === true) {
        setTableData(
          Array.isArray(res.data) ? res.data : Object.values(res.data)
        );
        const today = moment().startOf("day");
        const uniqueDateRanges = [
          ...new Set(
            Object.values(res.data).map((item) => {
              const startDate = moment(item.start_date);
              const endDate = moment(item.end_date);
              // Skip if both start and end are future
              if (startDate.isAfter(today) && endDate.isAfter(today)) {
                return null;
              }
              return `${startDate.format("MM-DD-YYYY")} - ${endDate.format(
                "MM-DD-YYYY"
              )}`;
            })
          ),
        ].filter(Boolean);

        const dateOptions = uniqueDateRanges.map((range) => ({
          label: range,
          value: range,
        }));
        setDateRange(dateOptions);
      } else {
        toast.error(res.message, {
          theme: "colored",
          autoClose: autocloseTiming,
        });
      }
    } catch (err) {
      console.log(err);
      toast.error(err, {
        theme: "colored",
        autoClose: autocloseTiming,
      });
    } finally {
      handleApiEnd();
    }
  };

  useEffect(() => {
    if (userInfo?.client_id) {
      getTableData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo]);
  const handleFilter = () => {
    const { start_date, end_date } = selectedOptions;
    const filtered = tableData.filter((item) => {
      const itemStart = moment(item.start_date);
      const itemEnd = moment(item.end_date);

      const filterStart = start_date !== "" ? moment(start_date) : null;
      const filterEnd = end_date !== "" ? moment(end_date) : null;

      // ✅ Check overlap between payroll range and filter range
      const overlaps =
        (!filterStart || itemEnd.isSameOrAfter(filterStart)) &&
        (!filterEnd || itemStart.isSameOrBefore(filterEnd));

      return overlaps;
    });
    setFilteredTableData(filtered);
    setAppliedFilters({ ...selectedOptions });
    setIsFilterApplied(true);
  };
  const tableDataArray = isFilterApplied ? filteredTableData : tableData;
  const handleClearFilter = () => {
    setSelectedOptions({
      end_date: "",
      start_date: "",
    });
    setFilteredTableData([]);
    setIsFilterApplied(false);
    setApplybtnDisable(true);
  };
  const handleChange = (e) => {
    setApplybtnDisable(false);
    const { id, value } = e.target;

    setSelectedOptions((prev) => {
      if (id === "start_date") {
        return {
          ...prev,
          start_date: value,
          end_date: "",
        };
      }
      return {
        ...prev,
        [id]: value,
      };
    });
  };

  const handleTransactionTypeChange = (selected) => {
    setSelectedOptions((prev) => ({
      ...prev,
      transaction_type: selected?.value || "",
    }));
  };
  const handleDateRangeChange = (selected) => {
    const dateRangeValue = selected?.value || "";
    // const paymentEventUuid = tableData.find((item) => {
    //   const itemStart = item.start_date;
    //   const itemEnd = item.end_date;
    //   return (
    //     `${moment(itemStart).format("MM-DD-YYYY")} - ${moment(itemEnd).format(
    //       "MM-DD-YYYY"
    //     )}` === dateRangeValue
    //   );
    // })?.payment_event_uuid;

    setSelectedOptions((prev) => ({
      ...prev,
      date_range: dateRangeValue,
    }));
  };

  // Payroll View Button
  const handleClick = (index) => {
    payrollView(index);
  };

  const payrollView = async (index) => {
    handleApiStart();
    const payLoad = {
      client_id: userInfo?.client_id,
      user_id: userInfo?.user_id,
      gusto_payroll_uuid: tableData[index].payroll_uuid,
    };
    try {
      const res = await postData("payroll-journal-download ", {}, payLoad);
      if (res.status === true) {
        setViewData(res.data);
        setShowModalPreview(true);
      } else {
        toast.error(res.message, {
          theme: "colored",
          autoClose: autocloseTiming,
        });
      }
    } catch (err) {
      toast.error(err, {
        theme: "colored",
        autoClose: autocloseTiming,
      });
    } finally {
      handleApiEnd();
    }
  };

  return (
    <>
      {apiCallsInProgress > 0 ? (
        <Loader />
      ) : (
        <div className="px-3 px-md-3 payroll-report-filter-wrapper">
          <OnboardHeading title="PAYROLL JOURNAL REPORTS" />
          <BackButtonComponent hasHistoryback />
          <PayrollFilter
            filterOptions={filterOptions}
            dateRange={dateRange}
            handleDateRangeChange={handleDateRangeChange}
            handleTransactionTypeChange={handleTransactionTypeChange}
            handleChange={handleChange}
            selectedOptions={selectedOptions}
            handleClearFilter={handleClearFilter}
            handleFilter={handleFilter}
            showFilter={showFilter}
            setShowFilter={setShowFilter}
            applybtnDisable={applybtnDisable}
          />
          <PayrollTable
            tableData={tableDataArray}
            handleClick={handleClick}
            // handleExport={handleExport}
            // csvLoading={csvLoading}
            // pdfLoading={pdfLoading}
            // setSortOrder={setSortOrder}
            // sortOrder={sortOrder}
          />
        </div>
      )}
      {showModalPreview && (
        <Modal
          show={showModalPreview}
          onHide={() => setShowModalPreview(false)}
          centered
          className="modal-payroll-preview"
        >
          <Modal.Header closeButton>
            <Modal.Title>Payroll Preview</Modal.Title>
          </Modal.Header>
          <PayrollPreview employeeData={viewData} />
        </Modal>
      )}
    </>
  );
};

export default PayrollReportFilter;
